import eventBus from './event-bus'

const STORAGE_KEY = 'debug:simulateOffline'

export function isOfflineSimulated() {
	return localStorage.getItem(STORAGE_KEY) === 'true'
}

// الحالة المدمجة التي يجب استخدامها بدلاً من navigator.onLine مباشرة في أي منطق أوفلاين
export function isOffline() {
	return isOfflineSimulated() || !navigator.onLine
}

export function setOfflineSimulated(value) {
	localStorage.setItem(STORAGE_KEY, value ? 'true' : 'false')

	if (navigator.serviceWorker && navigator.serviceWorker.controller) {
		navigator.serviceWorker.controller.postMessage({ type: 'SET_OFFLINE_SIMULATION', value })
	}

	eventBus.$emit('offline-simulation-changed', value)
}
